import React from 'react';
import { Scale, Shield, Target, TrendingUp } from 'lucide-react';
import CTASection from '../../components/CTASection';

const CopyrightLitigationPage = () => {
  return (
    <div>
      <div className="bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white py-20">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <h1 className="text-5xl font-bold mb-6">Copyright <span className="text-[#FF6B35]">Litigation</span></h1>
          <p className="text-xl text-gray-300 max-w-3xl">Aggressive federal court representation for copyright infringement cases. Protect your rights and recover maximum damages.</p>
        </div>
      </div>
      <div className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-4xl mx-auto space-y-6 text-lg text-gray-700">
            <p>When negotiations fail and infringement continues, federal litigation may be necessary to protect your copyrights. Our experienced attorneys handle all aspects of copyright litigation from filing complaints through trial and appeals.</p>
            <p>We pursue statutory damages (up to $150,000 per work for willful infringement), actual damages and profits, injunctive relief, and attorney fees. Our track record includes successful cases against major corporations, online pirates, and repeat infringers.</p>
          </div>
        </div>
      </div>
      <div className="py-20 bg-gray-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
            <div className="bg-white rounded-xl p-6 text-center">
              <Scale className="w-12 h-12 text-[#FF6B35] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Federal Court</h3>
              <p className="text-gray-700 text-sm">Expert representation in copyright cases</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <TrendingUp className="w-12 h-12 text-[#FF6B35] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Maximum Damages</h3>
              <p className="text-gray-700 text-sm">Pursue statutory damages up to $150,000 per work</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <Shield className="w-12 h-12 text-[#FF6B35] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Injunctive Relief</h3>
              <p className="text-gray-700 text-sm">Stop ongoing infringement permanently</p>
            </div>
            <div className="bg-white rounded-xl p-6 text-center">
              <Target className="w-12 h-12 text-[#FF6B35] mx-auto mb-4" />
              <h3 className="text-xl font-bold mb-3">Attorney Fees</h3>
              <p className="text-gray-700 text-sm">Recover your legal costs from infringers</p>
            </div>
          </div>
        </div>
      </div>
      <CTASection />
    </div>
  );
};

export default CopyrightLitigationPage;